import React from "react";
import Typography from "@mui/material/Typography";
import { formatEmpty, formatPipelineStatus } from "../../../../utils/formatHelpers";

export default function PipelineStatusCell(cell) {
  const formattedValue = formatPipelineStatus(cell.value);

  return (
    <span style={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          ...(formattedValue === "Open" ? {color: "success.60"} : {color: "black_solid.80"}),
        }}
      >
        {formatEmpty(formattedValue)}
      </Typography>
    </span>
  );
}
